import React, { useState, useEffect } from "react";
import { examenService } from "../services/examenService";
import { Loading } from "./common/Loading";
import "./AdministradorExamenes.css";

function AdministradorExamenes() {
  const [examenes, setExamenes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [confirmarEliminar, setConfirmarEliminar] = useState(null);

  // Cargar exámenes al montar el componente
  useEffect(() => {
    cargarExamenes();
  }, []);

  const cargarExamenes = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await examenService.obtenerTodos();
      setExamenes(data);
    } catch (err) {
      console.error("Error al cargar exámenes:", err);
      setError("Error loading exams. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleCrear = () => {
    // Navigate to CrearExamen for creating new exam
    window.location.href = "/create-exam";
  };

  const handleEditar = (examen) => {
    // Navigate to CrearExamen with edit mode
    window.location.href = `/create-exam?edit=${examen.id}`;
  };

  const handleEliminar = async (examenId) => {
    try {
      await examenService.eliminar(examenId);
      setConfirmarEliminar(null);
      await cargarExamenes();
      alert("Exam deleted successfully");
    } catch (err) {
      console.error("Error al eliminar examen:", err);
      alert("Error deleting exam. Please try again.");
    }
  };

  if (loading) {
    return (
      <div className="administrador-wrapper">
        <Loading fullScreen={true} />
      </div>
    );
  }

  return (
    <div className="administrador-wrapper">
      <main className="administrador-main">
        <div className="administrador-container">
          <div className="administrador-header-section">
            <h1 className="administrador-title">Exam Administrator</h1>
            <button className="btn-crear-examen" onClick={handleCrear}>
              + Create New Exam
            </button>
          </div>

          {error && <div className="error-message">{error}</div>}

          {examenes.length === 0 ? (
            <div className="no-examenes">
              <p>No exams available.</p>
              <button className="btn-crear-examen" onClick={handleCrear}>
                Create First Exam
              </button>
            </div>
          ) : (
            <div className="examenes-grid">
              {examenes.map((examen) => (
                <div key={examen.id} className="examen-card">
                  <div className="examen-card-header">
                    <h3 className="examen-card-title">{examen.titulo}</h3>
                    <div className="examen-card-actions">
                      <button
                        className="btn-editar"
                        onClick={() => handleEditar(examen)}
                        title="Edit exam"
                      >
                        ✏️
                      </button>
                      <button
                        className="btn-eliminar"
                        onClick={() => setConfirmarEliminar(examen)}
                        title="Delete exam"
                      >
                        🗑️
                      </button>
                    </div>
                  </div>
                  <div className="examen-card-body">
                    <p className="examen-descripcion">
                      {examen.descripcion || "No description"}
                    </p>
                    <div className="examen-stats">
                      <span className="stat-item">
                        📝 {examen.preguntas?.length || 0} questions
                      </span>
                      <span className="stat-item">
                        📂 {examen.categorias?.length || 0} categories
                      </span>
                      {examen.empresa && (
                        <span className="stat-item">
                          🏢 {examen.empresa.nombre}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </main>

      {/* Modal de confirmación de eliminación */}
      {confirmarEliminar && (
        <div
          className="modal-overlay"
          onClick={() => setConfirmarEliminar(null)}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Confirm Deletion</h3>
            <p>
              Are you sure you want to delete the exam "
              {confirmarEliminar.titulo}"? This action cannot be undone.
            </p>
            <div className="modal-actions">
              <button
                className="btn-cancelar"
                onClick={() => setConfirmarEliminar(null)}
              >
                Cancel
              </button>
              <button
                className="btn-confirmar-eliminar"
                onClick={() => handleEliminar(confirmarEliminar.id)}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdministradorExamenes;
